/**
 * Debounce to help with fast scrolling.
 * @param {Function} fn    - The function to debounce.
 * @param {number}   delay - The delay in milliseconds.
 *
 * @return {Function} - The debounced function.
 */
export default function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}
